import type { ReactNode } from "react";

export function FilterPill({
  label,
  pressed,
  onClick,
  ariaLabel,
  className,
}: {
  label: ReactNode;
  pressed: boolean;
  onClick: () => void;
  ariaLabel?: string;
  className?: string;
}) {
  const name = ariaLabel ?? (typeof label === "string" ? label : undefined);
  return (
    <button
      type="button"
      className={`filter-pill${pressed ? " on" : ""}${className ? ` ${className}` : ""}`}
      aria-pressed={pressed}
      aria-label={name}
      title={name}
      onClick={onClick}
    >
      {label}
    </button>
  );
}

export function segmentChipLabel(value: string): string {
  return value.replaceAll("_", " ");
}
